import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BadgePill } from '@connect-x-app/hybrid-ui';
import { MessageMention } from '@connect-x-app/shared-domain-models';
import { FlightroomInfoItem } from '@connect-x-app/web-ui';

type Props = {
  mention: MessageMention;
};

export const ExternalMentionInfoItem: FC<Props> = ({ mention }) => {
  const { t } = useTranslation();

  return (
    <FlightroomInfoItem
      avatar={'roleDefault'}
      rightSection={<BadgePill size={'xs'} text={t('CHAT.MENTIONS.STATUS.PENDING')} type="neutral" />}
      title={mention.label.toUpperCase()}
      value={t('CHAT.MENTIONS.NOTIFIED')}
    />
  );
};
